import { IIndicatorResponse } from '@kcftech/prometheus-client';
import { sdClient } from 'contexts/SDKClientContext';
import { useQueryCollection } from 'custom_hooks/data_hooks/useQueryCollection';
import { sortBy } from 'utils/array';

export const indicatorOrderBy = [
    ({ SystemSortOrder }: IIndicatorResponse) => SystemSortOrder,
    ({ Id }: IIndicatorResponse) => Id,
];

export const indicatorsQueryName = 'indicators';

export function useIndicatorCollection(indicatorIds: string[]) {
    return useQueryCollection<IIndicatorResponse, string>({
        queryName: indicatorsQueryName,
        itemIds: indicatorIds,
        itemQuery: (id) => sdClient.getIndicator({ indicatorId: id }),
        postTransform: (indicators) => sortBy(indicators, ...indicatorOrderBy),
    });
}
